import ChildrenPlugin from './plugin'

export default ChildrenPlugin
